<template>
  <div id="app">
    <router-view />
    <AddDomainModal />
    <LimitExceededModal />
    <NotifyWindow v-if="notifications.isVisible" />
    <div id="modals"></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AddDomainModal from '@/components/add-domain/AddDomainModal.vue'
import NotifyWindow from '@/components/notifications/NotifyWindow.vue'
import LimitExceededModal from '@/components/modals/LimitExceededModal.vue'

import { configureAmplitude } from './helpers/base/amplitude'

export default {
  name: 'App',
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    ...mapState('notifications', {
      notifications: state => state,
    }),
  },
  created() {
    configureAmplitude(this.userInfo?.userId)
  },
  components: {
    AddDomainModal,
    NotifyWindow,
    LimitExceededModal,
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');
@import './assets/styles/variables.css';
@import './assets/styles/metrics.css';

:root {
  scroll-behavior: auto;
}

/* Bootstrap 5.3 читает цвета из своих переменных — подменяем их токенами темы.
   Селектор с атрибутом, чтобы перебить bootstrap-овский [data-bs-theme=dark] */
:root,
html[data-theme] {
  --bs-body-bg: var(--bg-page);
  --bs-body-color: var(--text-primary);
  --bs-emphasis-color: var(--text-primary);
  --bs-secondary-color: var(--text-secondary2);
  --bs-tertiary-color: var(--text-secondary3);
  --bs-secondary-bg: var(--bg-surface-3);
  --bs-tertiary-bg: var(--bg-surface-2);
  --bs-border-color: var(--border-color);
  --bs-link-color: var(--main-color);
  --bs-link-hover-color: var(--button-primary-hover);
}

html {
  touch-action: none;
  background-color: var(--bg-page);
}
#app {
  font-family: 'Manrope', sans-serif;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background-color: var(--bg-page);
  overflow-x: hidden;
  color: var(--primary-color);
  font-size: 14px;
}
button {
  outline: none;
  border: none;
  color: var(--text-primary);
}
button:focus {
  outline: none;
}
a,
button:focus-visible {
  outline-offset: 0px;
  outline: none;
}
input {
  outline: none;
  border: none;
  font-size: 12px;
}
input,
select,
textarea {
  color: var(--text-primary);
}
input::placeholder,
textarea::placeholder {
  color: var(--text-secondary3);
}
h2 {
  font-weight: 500;
  font-size: 24px;
}
h3 {
  font-weight: normal;
  font-style: normal;
  font-size: 15px;
  color: var(--text-secondary2);
}
a {
  color: var(--main-color);
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
.table {
  margin-bottom: 0;
  color: var(--text-primary);
  --bs-table-bg: var(--bg-surface);
  --bs-table-color: var(--text-primary);
  --bs-table-border-color: var(--border-color);
}
.table > :not(:first-child) {
  border-top: none;
}
.table > :not(caption) > * > * {
  border-bottom-width: 0;
  padding: 0.5rem 0;
}
.table tr,
.table th,
.table td {
  padding: 0.5rem;
}
dl,
ol,
ul {
  margin-bottom: 0;
}

/* Компоненты Bootstrap, которые не читают переменные выше, — перекрываем токенами */
.text-muted {
  color: var(--text-secondary2) !important;
}
.dropdown-menu {
  background-color: var(--bg-surface);
  border-color: var(--border-color);
  color: var(--text-primary);
}
.dropdown-item {
  color: var(--text-primary);
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: var(--text-primary);
  background-color: var(--bg-hover);
}
.card {
  background-color: var(--bg-surface);
  border-color: var(--border-color);
  color: var(--text-primary);
}
.badge {
  color: var(--text-inverse);
}
hr {
  border-color: var(--border-color);
  opacity: 1;
}
</style>
